import { render, staticRenderFns } from "./researchDialog.vue?vue&type=template&id=4a81ee5c&scoped=true&"
import script from "./researchDialog.vue?vue&type=script&lang=js&"
export * from "./researchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81ee5c",
  null
  
)

export default component.exports